import { injectable } from "tsyringe";
import { DispatchApiRepository } from "@/app/infrastructures/repositories/api/DispatchApiRepository";
import { DispatchRepositoryInterface } from "@/data/persistences/repositories/contracts/DispatchRepositoryInterface";
import { DispatchListRequest } from "@/domain/entities/Dispatch";
import { UpdateDispatchRequestInterface } from "@/data/payload/contracts/DispatchRequest";
import { ApiRequestList } from "@/domain/entities/MainApp";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { ProcessUpdateDispatchRequest } from "@/data/payload/api/DispatchApiRequest";

@injectable()
export class DispatchPresenter implements DispatchRepositoryInterface {
  private repository: DispatchApiRepository;

  constructor(repository: DispatchApiRepository) {
    this.repository = repository;
  }

  getList(params: DispatchListRequest) {
    return this.repository.getList(params);
  }

  getDetail(id: number) {
    return this.repository.getDetail(id);
  }

  updateDispatch(payload: UpdateDispatchRequestInterface) {
    return this.repository.updateDispatch(payload);
  }

  getListTemporary(params: ApiRequestList): Promise<ResponsePayloadV2> {
    return this.repository.getListTemporary(params);
  }

  processUpdateDispatch(payload: ProcessUpdateDispatchRequest): Promise<ResponsePayloadV2> {
    return this.repository.processUpdateDispatch(payload);
  }
}
